@let widgetInDom = widgetInDom$ | async;

<div
  class="wrapper grid-max-width padding-left-gutter padding-right-gutter center z5"
  [ngClass]="{
    'fixed fill--pos': [LoginWidgetContext.BOOKING, LoginWidgetContext.MMB].includes(context),
    relative: ![LoginWidgetContext.BOOKING, LoginWidgetContext.MMB].includes(context),
  }"
>
  <div
    class="login-widget"
    [ngClass]="{
      'login-widget-open': isOpen$ | async,
      'booking-context': context === LoginWidgetContext.BOOKING,
      'mmb-context': context === LoginWidgetContext.MMB,
    }"
  >
    @if (widgetInDom) {
      <div class="widget-content overflow-hidden white-bg surface-primary elevation-level-3">
        <button
          class="absolute ms-medium-r ms-medium-t close"
          [ngClass]="{
            'white-text text-icon-reversed': (darkBg$ | async) === true,
            'nordic-blue-900-text text-icon-primary': (darkBg$ | async) === false,
          }"
          [attr.aria-label]="'actions.close' | finLocalization"
          [attr.title]="'actions.close' | finLocalization"
          (click)="close()"
        >
          <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.CLOSE_DELETE" />
        </button>
        @if ((loginStatus$ | async) === LoginStatus.LOGGED_IN) {
          <fin-profile-quick-view [profile$]="profile$" (popOverClosed)="close()" />
        }
        @if ((loginStatus$ | async) === LoginStatus.NOT_LOGGED_IN) {
          <div class="login-or-join grow relative z1">
            <div class="login-or-join-top relative ps-large-x ps-medium-t ps-large-b border-bottom z2">
              <span class="login-title nordic-blue-900-text text-icon-primary inline-block font-body-medium-bold">{{
                'navigation.login' | finLocalization
              }}</span>
              <span class="inline-block ms-large-b nordic-blue-900-text text-icon-primary font-body-medium">{{
                'loginWidget.loginText' | finLocalization
              }}</span>
              <fcom-button
                [text]="'navigation.login' | finLocalization"
                (clickBtn)="redirectToLogin()"
                class="block login-button"
              />
            </div>

            <div class="ps-large">
              <span class="nordic-blue-900-text text-icon-primary inline-block font-body-medium-bold">
                {{ 'loginWidget.joinTitle' | finLocalization }}
              </span>

              <span
                class="inline-block ps-large-b nordic-blue-900-text text-icon-primary font-body-medium"
                [innerHTML]="'loginWidget.joinText' | finLocalization | finSafe: 'html'"
              ></span>

              <fcom-button
                [theme]="ButtonTheme.SECONDARY_OUTLINE"
                [text]="'loginWidget.joinButton' | finLocalization"
                (clickBtn)="redirectToJoin()"
                class="block join-button"
              />
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
